<template>
  <el-cascader
    filterable
    v-model="casValue"
    :disabled="disabled"
    :clearable="widget.options.clearable"
    :placeholder="widget.options.placeholder"
    :style="{ width: widget.options.width }"
    :options="widget.options.remoteOptions"
    :show-all-levels="widget.options.showAllLevels"
    :props="{
      multiple: widget.options.multiple,
      checkStrictly: widget.options.checkStrictly,
      label: widget.options.props.label,
      value: widget.options.props.value,
    }"
    @[event]="eventMethod"
  >
  </el-cascader>
</template>

<script>
import bus from '../../../util/eventBus'
// import { debounce } from '../../../util/index'
import generateUtils from '../../../util/generateUtils'
export default {
  // 级联选择框
  name: 'sw-cascader',
  props: ['widget', 'cascader', 'config', 'disabled', 'models', 'dataType'],
  data() {
    return {
      casValue: this.cascader,
      casCombineValue: null,
      idName: 'id',
      pidName: 'pid',
      casValueModify: [],
    }
  },
  created() {
    const remoteQuery = this.widget.options.remoteQuery
    if (remoteQuery && remoteQuery.fromWidget) {
      remoteQuery.fromWidget.value = this.models[remoteQuery.fromWidget.key]
      // const key = 'models.' + this.widget.options.remoteQuery.fromWidget.key
      // this.$watch(
      //   remoteQuery.fromWidget.value,
      //   debounce(() => {
      //     this.getRemoteOptionsWithQuery()
      //   }, 500)
      // )
    }
    this.getRemoteOptions()
  },
  computed: {
    event() {
      return this.widget.eventOptions.eventType || null
    },
  },
  methods: {
    // 在remoteOptions树的每个节点上添加path，里面的值为从根节点到当前节点的id路径
    getAllPath(i, optionItem, item, len) {
      let j = i + 1
      optionItem.children.forEach(rItem => {
        rItem.path = JSON.parse(JSON.stringify(optionItem.path))
        if (rItem[this.idName] === item[j] || !item[j]) {
          rItem.path.push(rItem[this.idName])
          if (rItem.children && rItem.children.length > 0) {
            this.getAllPath(j, rItem, item, len)
          } else {
            this.casValueModify.push(rItem.path)
            console.log('mmm', rItem[this.idName], rItem.path)
          }
        }
      })
    },
    // 自定义事件触发
    eventMethod() {
      bus.$emit('eventMethod', this.widget)
    },
    getRemoteOptions() {
      // 获取级联数据
      generateUtils.getCascaderOptions(this.widget, this.dataType)
    },
    getRemoteOptionsWithQuery(val) {
      const remoteQuery = this.widget.options.remoteQuery
      remoteQuery.fromWidget.value = val
      generateUtils.getCascaderOptions(this.widget, this.dataType)
    },
  },
  watch: {
    casValue: {
      handler(val) {
        this.$emit('update:cascader', val)
      },
      deep: true,
      immediate: true,
    },
    cascader: {
      handler(val) {
        this.casValue = val
      },
      deep: true,
      immediate: true,
    },
    'widget.options.orgRootId': {
      handler(val) {
        if (this.widget.type === 'organization' && val) {
          this.casValue = []
        }
      },
    },
    models: {
      handler(val) {
        const remoteQuery = this.widget.options.remoteQuery
        if (remoteQuery && remoteQuery.fromWidget) {
          remoteQuery.fromWidget.value = val[remoteQuery.fromWidget.key]
        }
        this.getRemoteOptions()
      },
      deep: true,
    },
    'widget.options.remoteOptions': {
      handler() {
        if (
          this.widget.options.remoteOptions &&
          this.widget.options.remoteOptions.length > 0 &&
          !this.widget.options.checkStrictly &&
          this.widget.options.multiple &&
          this.casValue &&
          this.casValue?.length > 0
        ) {
          this.casCombineValue = JSON.parse(JSON.stringify(this.cascader))
          console.log(
            'pppppp',
            this.casCombineValue,
            this.widget.options.remoteOptions
          )
          this.casValueModify = []
          this.idName = this.widget.options.props.pk
          this.pidName = this.widget.options.props.ppk
          // const arr = []
          this.casCombineValue.forEach(item => {
            // [1, 2, 7]
            const len = item.length

            this.widget.options.remoteOptions.forEach(wItem => {
              wItem.path = [item[0]]
              if (wItem[this.idName] === item[0]) {
                if (wItem.children && wItem.children.length > 0) {
                  this.getAllPath(0, wItem, item, len)
                }
              }
            })
          })
          console.log('tttt', this.casValueModify)
          // 查询当前值里有没有非末端节点
          let flag = true
          this.casValue.forEach(item => {
            const itemText = item.join(',')
            const flagTemp = this.casValueModify.some(cItem => {
              const cItemText = cItem.join(',')
              if (cItemText === itemText) return true
              return false
            })
            if (flagTemp === false) {
              flag = false
            }
          })
          if (flag === false) {
            this.casValue = this.casValueModify
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped></style>
